<div data-testid="main_menu" class="menu">
  <ul app-submenu [item]="model" root="true" (click)="clearStoredFilters()"></ul>
</div>



// WEBPACK FOOTER //
// ./src/app/views/menu/menu.html